import React, { useContext, useState, useEffect } from 'react'

import CustomTable from '../../components/molecules/CustomTable'
import CustomSearch from '../../components/molecules/CustomSearch'

import FullScreenPopup from '../../components/organisms/FullScreenPopup'
import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '../../common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import Reorder from 'react-reorder'
import move from 'lodash-move'
import PropTypes from 'prop-types'
import { Button, Divider } from '@mui/material'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import SecondaryButton from '../../components/atoms/SecondaryButton'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import Loaders from '../../components/molecules/Loaders'
import SettingContext from '../../context/setting/settingContext'
import DynamicContext from '../../context/dynamic/dynamicContext'

import DropdownManage from './dropdown'
import { useLocation } from 'react-router-dom'
function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <div>
                    <>{children}</>
                </div>
            )}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.is_required,
    value: PropTypes.any.is_required,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const FieldValueManage = (props) => {
    const search = useLocation().search
    const editParams = new URLSearchParams(search).get('edit')

    const settingcontext = useContext(SettingContext)

    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const dynamiccontext = useContext(DynamicContext)
    const {
        single_property,
        getSingleProperty,
        propertyColumnAction,
        dynamicPagesFields,
        responseStatus: responseStatusDynamic,
    } = dynamiccontext

    const toggleFullScreenPopup = props.function
    const [data, setData] = useState({
        status: 'new',
        popup: false,
        id: 0,
    })

    const [reload, setReload] = useState(false)
    const [isLoading, setLoading] = useState(false)
    const [value, setValue] = useState(0)

    const [dynamicViewPageFields, setDynamicViewPageFields] = useState([])

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    const validationArray = Yup.object({
        view_page: Yup.number().required('Required!'),
        label: Yup.string()
            .max(
                props.lableLimit ? props.lableLimit : 50,
                'This field has to be exactly ' + props.lableLimit
                    ? props.lableLimit
                    : 50 + ' characters!'
            )
            .required('Required!'),
        placeholder: Yup.string().required('Required!'),
        type: Yup.string().required('Required!'),
        class: Yup.string().required('Required!'),
        // accept: Yup.string()
        //     .nullable()
        //     .when('type', {
        //         is: (type) => type === 'uploadDropZone',
        //         then: Yup.string().required('Required!'),
        //     }),
        multiple: Yup.boolean().nullable(),
        reorder: Yup.boolean().nullable(),
        icon_only: Yup.boolean().nullable(),
        folder: Yup.string()
            .nullable()
            .when('type', {
                is: (type) => type === 'uploadDropZone',
                then: Yup.string().required('Required!'),
            }),
        userType: Yup.string()
            .nullable()
            .when('view_page', {
                is: (type) => type === 3,
                then: Yup.string().required('Required!'),
            }),
        is_compress: Yup.boolean().nullable(),
        compress_quality: Yup.number().nullable(),
        compress_width: Yup.number().nullable(),
        compress_height: Yup.number().nullable(),
        customized_uploader: Yup.boolean().nullable(),
        active: Yup.boolean(),
        view_on: Yup.string()
            .nullable()
            .when('view_page', {
                is: (type) =>
                    dynamicViewPageFields.length &&
                    type === dynamicViewPageFields.view_page,
                then: Yup.string().required('Required!'),
            }),
        filter_order: Yup.number()
            .nullable()
            .when('search', {
                is: (type) => type === 1,
                then: Yup.number().positive(),
            }),
    })

    useEffect(() => {
        if (props.viewPage) {
            formik.values.view_page = props.viewPage
        }
    }, [props])

    const formik = useFormik({
        initialValues: {
            id: 0,
            view_page: props.viewPage,
            label: '',
            placeholder: '',
            type: '',
            name: '',
            show_order: 0,
            is_deletable: 1,
            is_default: 0,
            is_required: 0,
            class: '',
            date_disable_past: 0,
            diff_name: 0,
            custom_class: 0,
            variable_name: '',
            accept: '',
            multiple: 0,
            search: 0,
            search_type: '',
            reorder: 0,
            folder: '',
            for_organization: 0,
            icon_only: 0,
            for_buyer: 0,
            autoFocus: 0,
            sub_select: 0,
            sub_level: 0,
            sub_field: '',
            webcam: 0,
            diff_value: 0,
            userType: '',
            country: 0,
            city: 0,
            state: 0,
            active: 1,
            location: 0,
            is_compress: 0,
            compress_quality: 0,
            compress_width: 0,
            compress_height: 0,
            customized_uploader: 0,
            selectType: 'default',
            view_on: [],
            filter_order: 0,
            content: '',
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            let value = values
            value.view_page = value.view_page || props.viewPage
            if (!value.diff_name) {
                value.name = value.label
                    .toLowerCase()
                    .replace(/[^a-zA-Z0-9_ ]/g, '')
                    .replace(/ /g, '_')
            }
            value.country = 0
            value.state = 0
            value.location = 0
            value.city = 0
            if (value.type === 'select' || value.type === 'multiselect') {
                if (value.selectType === 'country') {
                    value.country = 1
                } else if (value.selectType === 'state') {
                    value.state = 1
                } else if (value.selectType === 'sub_select') {
                    value.sub_select = 1
                } else if (value.selectType === 'city') {
                    value.city = 1
                } else if (value.selectType === 'table') {
                    value.location = 1
                }
            }
            value.for_organization = 0
            value.for_buyer = 0
            if (value.view_page === 3) {
                if (value.userType) {
                    if (value.userType === 'for_organization') {
                        value.for_organization = 1
                    } else if (value.userType === 'for_buyer') {
                        value.for_buyer = 1
                    } else if (value.userType === 'both') {
                        value.for_buyer = 1
                        value.for_organization = 1
                    }
                }
            }

            propertyColumnAction(value)
            setLoading(true)
        },
    })
    const details = {
        formik: formik,
        data: [
            {
                content: <h4 className="fmTitle">Property Information</h4>,
                type: 'misc',
                class: `col-12 mb-4`,
            },
            {
                label: 'User Type',
                placeholder: 'Select User Type',
                class: `col-sm-12 col-12 ${
                    formik.values.view_page === 3 ? '' : 'd-none'
                }`,
                type: 'select',
                options: [
                    { show: 'Both', value: 'both' },
                    { show: 'Seller', value: 'for_organization' },
                    { show: 'Buyer', value: 'for_buyer' },
                ],
                name: 'userType',
            },
            {
                label: 'Label',
                placeholder: 'Enter a label',
                type: 'text',
                class: `col-sm-6 col-12`,
                name: 'label',
            },
            // {
            //     content: '',
            //     type: 'misc',
            //     class: `col-sm-6 col-12`,
            // },
            {
                label: 'Placeholder',
                placeholder: 'Enter a placeholder',
                type: 'text',
                class: 'col-sm-6 col-12',
                name: 'placeholder',
            },

            // {
            //     label: 'Variable',
            //     placeholder: 'Enter variable',
            //     type: 'text',
            //     class: 'col-sm-6 col-12',
            //     name: 'name',
            // },
            {
                label: 'Property type',
                placeholder: 'Select property type',
                class: `col-md-3 col-sm-6 col-12`,
                type: 'select',
                disabled: formik.values.is_default ? true : false,
                options: [
                    // password_checker
                    // check
                    { show: 'Check Box', value: 'checkbox' },
                    { show: 'CKEditor', value: 'ckeditor' },
                    { show: 'Date', value: 'date' },
                    { show: 'Date Time', value: 'datetime' },
                    { show: 'Decimal', value: 'float' },
                    { show: 'Tiny Editor', value: 'tinymce' },
                    { show: 'Email', value: 'email' },
                    { show: 'Misc', value: 'misc' },
                    { show: 'Month', value: 'month' },
                    { show: 'Multi Check Box', value: 'checkboxarray' },
                    { show: 'Multi Select', value: 'multiselect' },
                    { show: 'Number', value: 'number' },
                    { show: 'Password', value: 'password' },
                    { show: 'Phone', value: 'phone' },
                    { show: 'CKEditor5', value: 'ckeditor5' },
                    { show: 'Radio', value: 'radio' },
                    { show: 'Select', value: 'select' },
                    { show: 'Switch', value: 'switch' },
                    { show: 'Text', value: 'text' },
                    { show: 'MultiDate', value: 'multidate' },
                    { show: 'Text Area', value: 'textarea' },
                    { show: 'Time', value: 'time' },
                    { show: 'Upload File', value: 'uploadDropZone' },

                    // { show: 'Color Picker', value: 'colorpicker' },
                ],
                name: 'type',
            },
            {
                label: 'Property size',
                placeholder: 'Select property size',
                class: `col-md-3 col-sm-6 col-12`,
                type: formik.values.custom_class ? 'text' : 'select',
                options: [
                    { show: 'Col 1', value: 'col-sm-1 col-12' },
                    { show: 'Col 2', value: 'col-sm-2 col-12' },
                    { show: 'Col 3 (Small)', value: 'col-sm-3 col-12' },
                    { show: 'Col 4', value: 'col-sm-4 col-12' },
                    { show: 'Col 5', value: 'col-sm-5 col-12' },
                    { show: 'Col 6 (Medium)', value: 'col-sm-6 col-12' },
                    { show: 'Col 7', value: 'col-sm-7 col-12' },
                    { show: 'Col 8', value: 'col-sm-8 col-12' },
                    { show: 'Col 9', value: 'col-sm-9 col-12' },
                    { show: 'Col 10', value: 'col-sm-10 col-12' },
                    { show: 'Col 11', value: 'col-sm-11 col-12' },
                    { show: 'Col 12 (Large)', value: 'col-sm-12 col-12' },
                ],
                name: 'class',
            },
            {
                label: 'View on pages',
                placeholder: 'View on pages',
                class: `col-sm-6 col-12 ${
                    dynamicViewPageFields.length ? '' : 'd-none'
                }`,
                type: 'multiselect',
                options: dynamicViewPageFields.length
                    ? dynamicViewPageFields.map((dynamicOption) => {
                          let dynamicValue = {}
                          dynamicValue.show = dynamicOption.type
                          dynamicValue.value = dynamicOption.id
                          return dynamicValue
                      })
                    : [],
                name: 'view_on',
            },
            {
                label: <>Custom Class</>,
                type: 'switch',
                class: `col-sm-6 col-12 fmCustom`,
                name: 'custom_class',
            },
            {
                label: 'Accepted Files',
                placeholder: 'Select Accepted Files',
                disabled: formik.values.is_default ? true : false,
                class: `col-sm-6 col-12 ${
                    formik.values.type === 'uploadDropZone' ? '' : 'd-none'
                }`,
                type: 'select',
                options: [
                    { show: 'Only Image', value: 'image/*' },
                    { show: 'Only Video', value: 'video/*' },
                    { show: 'Only PDF File', value: 'application/pdf' },
                ],
                name: 'accept',
            },
            {
                label: 'Content',
                placeholder: 'Enter Content',
                class: `col-sm-6 col-12 ${
                    formik.values.type === 'misc' ? '' : 'd-none'
                }`,
                type: 'text',
                name: 'content',
            },
            {
                label: 'Folder name',
                placeholder: 'Create a folder name',
                type: 'text',
                disabled: formik.values.is_default ? true : false,
                class: `col-sm-6 col-12 ${
                    formik.values.type === 'uploadDropZone' ? '' : 'd-none'
                }`,
                name: 'folder',
            },

            {
                label: 'Select view type',
                placeholder: 'Select view type',
                class: `col-sm-6 col-12 ${
                    formik.values.type === 'select' ||
                    formik.values.type === 'multiselect'
                        ? ''
                        : 'd-none'
                }`,
                type: 'select',
                options: [
                    { show: 'Default', value: 'default' },
                    { show: 'State', value: 'state' },
                    { show: 'Country', value: 'country' },
                    { show: 'City', value: 'city' },
                    { show: 'Sub Select', value: 'sub_select' },
                    { show: 'Location', value: 'table' },
                ],
                name: 'selectType',
            },
            {
                label: 'Select sub-level',
                placeholder: 'Select sub-level',
                class: `col-sm-6 col-12 ${
                    (formik.values.type === 'select' ||
                        formik.values.type === 'multiselect') &&
                    formik.values.selectType === 'sub_select'
                        ? ''
                        : 'd-none'
                }`,
                type: 'select',
                options: [
                    { show: '0', value: '0' },
                    { show: '1', value: '1' },
                ],
                name: 'sub_level',
            },
            {
                label: 'Select sub-level',
                placeholder: 'Select sub-level',
                class: `col-sm-6 col-12 ${
                    (formik.values.type === 'select' ||
                        formik.values.type === 'multiselect') &&
                    formik.values.selectType === 'sub_select' &&
                    formik.values.sub_level !== 0
                        ? ''
                        : 'd-none'
                }`,
                type: 'select',
                options: props.tableBody
                    .filter(
                        (maincat) =>
                            maincat.sub_select === 1 &&
                            maincat.sub_level < formik.values.sub_level
                    )
                    .map((maincat) => {
                        let categoryChanged = {}
                        categoryChanged.show = maincat.label
                        categoryChanged.value = maincat.name
                        return categoryChanged
                    }),
                name: 'sub_field',
            },
            // {
            //     label: 'Active',
            //     placeholder: 'Make Active',
            //     type: 'switch',
            //     class: 'col-6',
            //     name: 'active',
            // },
            {
                content: <h4 className="fmTitle">Property Configuration</h4>,
                type: 'misc',
                class: `col-12 mb-4`,
            },
            {
                label: (
                    <>
                        Add to filter list
                        <span className="switchHelperText">
                            <span className="material-icons">info_outline</span>
                            By enabling, you allow to add this property to the
                            search filters.
                        </span>
                    </>
                ),
                type: 'switch',
                class: `col-sm-6 col-12 ${
                    formik.values.view_page === 1 &&
                    (formik.values.type === 'select' ||
                        formik.values.type === 'multiselect' ||
                        formik.values.type === 'checkboxarray' ||
                        formik.values.type === 'checkbox' ||
                        formik.values.type === 'radio' ||
                        formik.values.type === 'date')
                        ? ''
                        : 'd-none'
                }`,
                name: 'search',
            },
            {
                label: (
                    <>
                        Enable Value for Dropdown fields
                        <span className="switchHelperText">
                            <span className="material-icons">info_outline</span>
                            By enabling, you allow to store value for the
                            dropdown values.
                        </span>
                    </>
                ),
                type: 'switch',
                class: `col-sm-6 col-12 ${
                    formik.values.type === 'select' ||
                    formik.values.type === 'multiselect'
                        ? ''
                        : 'd-none'
                }`,
                name: 'diff_value',
            },
            {
                label: 'Search type',
                placeholder: 'Search type',
                type: 'select',
                class: `col-sm-6 col-12 fmInput ${
                    formik.values.search ? '' : 'd-none'
                }`,
                options: [
                    { show: 'Checkbox', value: 'checkbox' },
                    { show: 'Radio', value: 'radio' },
                ],
                name: 'search_type',
            },
            {
                label: 'Search Filter Order',
                placeholder: 'Enter Order Number you want to arrange filters',
                type: 'number',
                class: `col-sm-6 col-12 fmInput ${
                    formik.values.search ? '' : 'd-none'
                }`,
                name: 'filter_order',
            },
            {
                content: <Divider />,
                type: 'misc',
                class: `col-12 fmDiv ${formik.values.search ? '' : 'd-none'}`,
            },
            {
                label: (
                    <>
                        Upload multiple files
                        <span className="switchHelperText">
                            <span className="material-icons">info_outline</span>
                            By enabling, you allow the user to upload multiple
                            files.
                        </span>
                    </>
                ),
                placeholder: 'Multiple Files',
                // disabled: formik.values.is_default ? true : false,
                type: 'switch',
                class: `col-sm-6 col-12 ${
                    formik.values.type === 'uploadDropZone' &&
                    formik.values.accept !== 'application/pdf'
                        ? ''
                        : 'd-none'
                }`,
                name: 'multiple',
            },
            {
                label: (
                    <>
                        Upload Image from Webcam
                        <span className="switchHelperText">
                            <span className="material-icons">info_outline</span>
                            By enabling, you allow the user to upload images
                            through webcam.
                        </span>
                    </>
                ),
                placeholder: 'Allow Webcam',
                // disabled: formik.values.is_default ? true : false,
                type: 'switch',
                class: `col-sm-6 col-12 ${
                    formik.values.type === 'uploadDropZone' &&
                    formik.values.accept === 'image/*'
                        ? ''
                        : 'd-none'
                }`,
                name: 'webcam',
            },
            {
                label: (
                    <>
                        Make this a required field
                        <span className="switchHelperText">
                            <span className="material-icons">info_outline</span>
                            By enabling, you are making this property a
                            mandatory field.
                        </span>
                    </>
                ),
                placeholder: 'Make Required',
                type: 'switch',
                class: 'col-md-6 col-12',
                // disabled: formik.values.is_default ? true : false,
                name: 'is_required',
            },
            {
                label: (
                    <>
                        Disable editing from input field
                        <span className="switchHelperText">
                            <span className="material-icons">info_outline</span>
                            By enabling, you allow to update the value only by
                            clicking on it.
                        </span>
                    </>
                ),
                placeholder: 'Icon Input only',
                type: 'switch',
                class: `col-sm-6 col-12 ${
                    formik.values.type === 'datetime' ? '' : 'd-none'
                }`,
                name: 'icon_only',
            },

            {
                content: <Divider />,
                type: 'misc',
                class: `col-12 fmDiv ${
                    formik.values.type === 'uploadDropZone' &&
                    formik.values.accept !== 'application/pdf'
                        ? ''
                        : 'd-none'
                }`,
            },
            {
                label: (
                    <>
                        Enable image reorder
                        <span className="switchHelperText">
                            <span className="material-icons">info_outline</span>
                            By enabling, you can reorder the position of the
                            images easily.
                        </span>
                    </>
                ),
                type: 'switch',
                class: `col-sm-6 col-12 ${
                    formik.values.type === 'uploadDropZone' &&
                    formik.values.accept !== 'application/pdf'
                        ? ''
                        : 'd-none'
                }`,
                // disabled: formik.values.is_default ? true : false,
                name: 'reorder',
            },
            {
                label: (
                    <>
                        Change Upload View
                        <span className="switchHelperText">
                            <span className="material-icons">info_outline</span>
                            By enabling, you are changing the default upload
                            view.
                        </span>
                    </>
                ),
                type: 'switch',
                class: `col-sm-6 col-12 ${
                    formik.values.type === 'uploadDropZone' ? '' : 'd-none'
                }`,
                name: 'customized_uploader',
            },
            {
                label: (
                    <>
                        Enable image compression
                        <span className="switchHelperText">
                            <span className="material-icons">info_outline</span>
                            By enabling, you allow the images to be compressed
                            before being uploaded.
                        </span>
                    </>
                ),
                type: 'switch',
                class: `col-sm-6 col-12 ${
                    formik.values.type === 'uploadDropZone' &&
                    formik.values.accept !== 'application/pdf'
                        ? ''
                        : 'd-none'
                }`,
                name: 'is_compress',
            },
            {
                label: 'Enter compress quality',
                placeholder: 'Enter compress quality',
                type: 'number',
                class: `col-sm-6 col-12 ${
                    formik.values.is_compress ? 'mt-4' : 'd-none'
                }`,
                name: 'compress_quality',
            },
            {
                label: 'Enter compress width',
                placeholder: 'Enter compress width',
                type: 'number',
                class: `col-sm-6 col-12 ${
                    formik.values.is_compress ? 'mt-4' : 'd-none'
                }`,
                name: 'compress_width',
            },
            {
                label: 'Enter compress height',
                placeholder: 'Enter compress height',
                type: 'number',
                class: `col-sm-6 col-12 ${
                    formik.values.is_compress ? '' : 'd-none'
                }`,
                name: 'compress_height',
            },

            {
                content: <Divider />,
                type: 'misc',
                class: `col-12 fmDiv ${formik.values.diff_name ? 'mb-3' : ''}`,
            },

            {
                label: (
                    <>
                        Choose a different variable name
                        <span className="switchCautionText">
                            <span className="material-icons">warning</span>
                            This is a development feature. Change this only if
                            you know what you are doing.
                        </span>
                    </>
                ),
                // disabled: formik.values.diff_name ? true : false,
                type: 'switch',
                class: `col-sm-6 col-12 fmCustom`,
                name: 'diff_name',
            },

            {
                label: 'Variable name',
                placeholder: `Enter a variable name`,
                type: 'text',
                disabled: formik.values.is_default ? true : false,
                class: `col-sm-6 col-12 fmInput ${
                    formik.values.diff_name ? '' : 'd-none'
                }`,
                name: 'variable_name',
                helperText: 'Make sure to only use small letters.',
            },
            {
                content: <Divider />,
                type: 'misc',
                class: `col-12 fmDiv`,
            },
        ],
    }
    useEffect(() => {
        setData(props.data)
        setValue(0)
    }, [props.data])

    useEffect(() => {
        if (dynamicPagesFields) {
            if (dynamicPagesFields.from === 'getAllDynamicPagesFields') {
                let fetchedData = dynamicPagesFields.records.length
                    ? dynamicPagesFields.records.filter(
                          (fields) =>
                              fields.view_page === props.viewPage &&
                              fields.active === 1
                      )
                    : []
                setDynamicViewPageFields(fetchedData)
            }
        }
    }, [dynamicPagesFields, props.data])

    useEffect(() => {
        if (data) {
            if (data.status === 'edit') {
                formik.values.id = data.data.id
                getSingleProperty({
                    id: formik.values.id,
                    table: 'dynamic_fields',
                })
                setLoading(true)
            } else {
                resetFrom()
            }
        }
    }, [data])

    useEffect(() => {
        if (single_property.record && data.status === 'edit') {
            const template = single_property.record
            formik.setFieldValue('id', template.id)
            formik.setFieldValue('label', template.label)
            formik.setFieldValue('placeholder', template.placeholder)
            formik.setFieldValue('type', template.type)
            formik.setFieldValue('variable_name', template.name)
            formik.setFieldValue('show_order', template.show_order)
            formik.setFieldValue('is_default', template.is_default)
            formik.setFieldValue('is_required', template.is_required)
            formik.setFieldValue('class', template.class)
            formik.setFieldValue('is_deletable', template.is_deletable)
            formik.setFieldValue(
                'date_disable_past',
                template.date_disable_past
            )
            formik.setFieldValue('accept', template.accept)
            formik.setFieldValue('multiple', template.multiple)
            formik.setFieldValue('webcam', template.webcam)
            formik.setFieldValue('reorder', template.reorder)
            formik.setFieldValue('icon_only', template.icon_only)
            formik.setFieldValue('diff_name', template.diff_name)
            formik.setFieldValue('custom_class', template.custom_class)
            formik.setFieldValue('folder', template.folder)
            formik.setFieldValue('search', template.search)
            formik.setFieldValue('search_type', template.search_type)
            formik.setFieldValue('sub_select', template.sub_select)
            formik.setFieldValue('sub_level', template.sub_level)
            formik.setFieldValue('sub_field', template.sub_field)
            formik.setFieldValue('diff_value', template.diff_value)
            formik.setFieldValue('country', template.country)
            formik.setFieldValue('city', template.city)
            formik.setFieldValue('state', template.state)
            formik.setFieldValue(
                'customized_uploader',
                template.customized_uploader
            )
            formik.setFieldValue('is_compress', template.is_compress)
            formik.setFieldValue('compress_quality', template.compress_quality)
            formik.setFieldValue('compress_width', template.compress_width)
            formik.setFieldValue('compress_height', template.compress_height)
            formik.setFieldValue('content', template?.content)
            formik.setFieldValue('active', template.active)
            formik.setFieldValue('filter_order', template.filter_order)

            if (template.type === 'select' || template.type === 'multiselect') {
                if (template.country === 1) {
                    formik.setFieldValue('selectType', 'country')
                } else if (template.state === 1) {
                    formik.setFieldValue('selectType', 'state')
                } else if (template.sub_select === 1) {
                    formik.setFieldValue('selectType', 'sub_select')
                } else if (template.city === 1) {
                    formik.setFieldValue('selectType', 'city')
                } else if (template.location === 1) {
                    formik.setFieldValue('selectType', 'table')
                }
            }

            formik.setFieldValue('for_organization', template.for_organization)
            formik.setFieldValue('for_buyer', template.for_buyer)

            if (formik.values.view_page === 3) {
                if (
                    template.for_organization === 1 &&
                    template.for_buyer === 1
                ) {
                    formik.setFieldValue('userType', 'both')
                } else if (template.for_organization === 1) {
                    formik.setFieldValue('userType', 'for_organization')
                } else if (template.for_buyer === 1) {
                    formik.setFieldValue('userType', 'for_buyer')
                }
            }
            let view_on_values = template.view_on
                ? template.view_on.toString().split(',').map(Number)
                : []
            formik.setFieldValue('view_on', view_on_values)
            setReload(!reload)
        } else {
            resetFrom()
        }
        setLoading(false)
    }, [single_property])

    const resetFrom = () => {
        formik.values.id = 0
        formik.setFieldValue('label', '')
        formik.setFieldValue('placeholder', '')
        formik.setFieldValue('variable_name', '')
        formik.setFieldValue('class', '')
        formik.setFieldValue('is_required', 0)
        formik.setFieldValue('reorder', 0)
        formik.setFieldValue('type', '')
        formik.setFieldValue('active', 1)
        formik.setFieldValue('filter_order', 0)
        formik.handleReset()
    }

    const handleClose = () => {
        toggleFullScreenPopup(false, 'new', 0)
        resetFrom()
    }

    useEffect(() => {
        if (formik.values.variable_name) {
            formik.values.name = formik.values.variable_name
                .toLowerCase()
                .replace(/[^a-zA-Z0-9_ ]/g, '')
                .replace(/ /g, '_')
        }
    }, [formik.values.variable_name])

    useEffect(() => {
        if (responseStatusDynamic) {
            if (responseStatusDynamic.status === 'success') {
                if (responseStatusDynamic.from === 'propertyColumnAction') {
                    if (
                        (formik.values.type === 'select' &&
                            (formik.values.selectType === 'default' ||
                                formik.values.selectType === 'sub_select')) ||
                        formik.values.type === 'checkboxarray' ||
                        (formik.values.type === 'multiselect' &&
                            formik.values.selectType === 'default') ||
                        formik.values.type === 'radio'
                    ) {
                        if (responseStatusDynamic.data.id) {
                            setData({
                                popup: true,
                                status: 'edit',
                                data: {
                                    id: responseStatusDynamic.data.id,
                                },
                            })
                            setValue(1)
                        }
                    } else {
                        toggleFullScreenPopup(false)
                    }
                }
            }
            setLoading(false)
        }
    }, [responseStatusDynamic])

    return (
        <FullScreenPopup
            modaltitle={
                data.status === 'new' ? 'Add New Property' : 'Edit Property'
            }
            open={data.popup}
            handleClose={() => handleClose()}
        >
            {isLoading ? (
                <div className="fieldsLoader">
                    <Loaders isLoading={isLoading} />
                </div>
            ) : (
                <>
                    <div className="dynamicFieldsCnt mt-4">
                        <div className="fspBody">
                            {((formik.values.type === 'select' &&
                                formik.values.selectType === 'default') ||
                                formik.values.selectType === 'sub_select' ||
                                formik.values.type === 'checkboxarray' ||
                                formik.values.type === 'multiselect' ||
                                formik.values.type === 'radio') &&
                            data.status === 'edit' ? (
                                <>
                                    <AppBar
                                        position="static"
                                        className="tabHeader mb-4"
                                    >
                                        <Tabs
                                            value={value}
                                            onChange={handleChange}
                                            aria-label="simple tabs example"
                                        >
                                            <Tab
                                                label="Details"
                                                {...a11yProps(0)}
                                            />
                                            <Tab
                                                label="Values"
                                                {...a11yProps(1)}
                                            />
                                        </Tabs>
                                    </AppBar>
                                </>
                            ) : null}

                            <TabPanel value={value} index={0}>
                                <form
                                    onSubmit={formik.handleSubmit}
                                    autoComplete="nofill"
                                >
                                    <div className="row">
                                        {mapData(details)}
                                    </div>
                                    <div className="actionButton d-flex justify-content-center align-items-center">
                                        {/* {formik.values.is_default ? null : ( */}
                                        <>
                                            <SecondaryButton
                                                id="field_value_reset"
                                                label="Reset"
                                                type="reset"
                                                onClick={() => resetFrom()}
                                            />
                                            <PrimaryButton
                                                id="field_value_submit"
                                                type="submit"
                                                label="Submit"
                                            />
                                        </>
                                        {/* )} */}
                                    </div>
                                </form>
                            </TabPanel>
                            <TabPanel value={value} index={1}>
                                <>
                                    {(formik.values.type === 'select' ||
                                        formik.values.type ===
                                            'checkboxarray' ||
                                        formik.values.type === 'multiselect' ||
                                        formik.values.type === 'radio') &&
                                    data.status === 'edit' ? (
                                        <>
                                            <DropdownManage
                                                name={formik.values.name}
                                                subLevel={
                                                    formik.values.sub_level
                                                }
                                                subField={
                                                    formik.values.sub_field
                                                }
                                                diff_value={
                                                    formik.values.diff_value
                                                }
                                            />
                                        </>
                                    ) : null}
                                </>
                            </TabPanel>
                        </div>
                    </div>
                </>
            )}
        </FullScreenPopup>
    )
}

export default FieldValueManage
